import axiosClient from "../api/axiosClient";

/**
 * Cross-event team roster — new backend endpoints (see WebAPI's
 * EventsController.MySubPromoters / EventAssistantController.MyAssistants),
 * added specifically for this page since nothing in the app previously
 * listed a promoter's sub-promoters/business assistants across all their
 * events at once (only per-event, via eventDetailService.js).
 */
export const getMySubPromoters = () => axiosClient.get("/Events/MySubPromoters");

export const getMyAssistants = () => axiosClient.get("/EventAssistant/MyAssistants");
